{
  "tiers": {
    "green": {
      "gem": "riftstone_green",
      "segments": [
        {
          "empty": true
        },
        {
          "gold": 1000
        },
        {
          "gold": 3000
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "item": "jewelry_scroll",
          "qty": 1
        },
        {
          "pool": [
            "mithril_helm",
            "nightveil_hood",
            "moonsilk_hat",
            "sanctified_circlet",
            "mithril_gauntlets",
            "nightveil_grips",
            "moonsilk_wraps",
            "sanctified_gloves",
            "mithril_boots",
            "nightveil_treads",
            "moonsilk_slippers",
            "sanctified_boots",
            "mithril_plate",
            "nightveil_jerkin",
            "moonsilk_robe",
            "sanctified_vestment",
            "mithril_shield"
          ],
          "label": "Mithril armor"
        },
        {
          "pool": [
            "mithril_sword",
            "mithril_daggers",
            "mithril_staff",
            "mithril_mace",
            "mithril_waraxe",
            "mithril_rime_daggers"
          ],
          "label": "Mithril weapon"
        },
        {
          "gold": 8000
        },
        {
          "item": "riftstone_blue",
          "qty": 1
        },
        {
          "pool": ["riftshard_ring", "riftshard_earring"],
          "label": "Riftshard jewel"
        }
      ]
    },
    "blue": {
      "gem": "riftstone_blue",
      "segments": [
        {
          "empty": true
        },
        {
          "gold": 5000
        },
        {
          "gold": 12000
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "item": "jewelry_scroll",
          "qty": 1
        },
        {
          "pool": [
            "dragon_helm",
            "drakescale_hood",
            "emberweave_hat",
            "dawnforged_circlet",
            "dragon_gauntlets",
            "drakescale_grips",
            "emberweave_wraps",
            "dawnforged_gloves",
            "dragon_boots",
            "drakescale_treads",
            "emberweave_slippers",
            "dawnforged_boots",
            "dragon_plate",
            "drakescale_jerkin",
            "emberweave_robe",
            "dawnforged_vestment",
            "dragon_shield"
          ],
          "label": "Dragon armor"
        },
        {
          "pool": [
            "dragon_sword",
            "dragon_daggers",
            "dragon_staff",
            "dragon_mace",
            "dragon_wingblade",
            "dragon_scythe",
            "dragon_storm_daggers"
          ],
          "label": "Dragon weapon"
        },
        {
          "item": "obsidian_hoop",
          "qty": 1
        },
        {
          "gold": 40000
        },
        {
          "item": "riftstone_violet",
          "qty": 1
        },
        {
          "pool": ["riftbound_earring", "riftbound_belt"],
          "label": "Riftbound jewel"
        }
      ]
    },
    "violet": {
      "gem": "riftstone_violet",
      "segments": [
        {
          "empty": true
        },
        {
          "gold": 25000
        },
        {
          "gold": 60000
        },
        {
          "item": "jewelry_scroll",
          "qty": 1
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "pool": [
            "titan_sword",
            "titan_greataxe",
            "phantom_daggers",
            "astral_staff",
            "seraphic_mace"
          ],
          "label": "Level 55 weapon"
        },
        {
          "pool": [
            "titan_shield",
            "titan_helm",
            "titan_plate",
            "titan_gauntlets",
            "titan_boots",
            "phantom_hood",
            "phantom_jerkin",
            "phantom_grips",
            "phantom_treads",
            "astral_hat",
            "astral_robe",
            "astral_wraps",
            "astral_slippers",
            "seraphic_circlet",
            "seraphic_vestment",
            "seraphic_gloves",
            "seraphic_boots"
          ],
          "label": "Level 55 armor"
        },
        {
          "gold": 150000
        },
        {
          "item": "colony_scroll",
          "qty": 1,
          "announce": true
        },
        {
          "pool": [
            "warlord_signet",
            "emberbound_belt",
            "frostbound_belt",
            "stormbound_belt",
            "earring_of_the_vanguard",
            "earring_of_the_shadow",
            "earring_of_the_arcanist",
            "earring_of_the_devout",
            "bloodstone_ring",
            "moonglass_ring"
          ],
          "label": "Unique jewel",
          "announce": true
        },
        {
          "pool": [
            "hellmaw_cleaver",
            "fangs_of_hellmaw",
            "staff_of_the_old_root",
            "hollowbell_mace"
          ],
          "label": "Unique weapon",
          "announce": true
        },
        {
          "pool": [
            "heartsplitter",
            "duskreaver_daggers",
            "staff_of_the_sundered_sky",
            "crownforge_maul"
          ],
          "label": "Legendary weapon",
          "announce": true
        },
        {
          "pool": ["riftcrown_pendant", "riftwalker_cloak"],
          "label": "Rift regalia",
          "announce": true
        }
      ]
    },
    "jade": {
      "gem": "jade_coffer",
      "segments": [
        {
          "gold": 800
        },
        {
          "gold": 1500
        },
        {
          "gold": 3000
        },
        {
          "pool": [
            "steel_shield",
            "steel_helm",
            "steel_plate",
            "steel_gauntlets",
            "steel_boots",
            "stalker_hood",
            "stalker_jerkin",
            "stalker_grips",
            "stalker_treads",
            "silkweave_hat",
            "silkweave_robe",
            "silkweave_wraps",
            "silkweave_slippers",
            "cleric_circlet",
            "cleric_vestment",
            "cleric_gloves",
            "cleric_boots"
          ],
          "label": "Steel armor"
        },
        {
          "pool": [
            "steel_sword",
            "steel_falchion",
            "steel_daggers",
            "steel_venom_daggers",
            "steel_staff",
            "steel_mace"
          ],
          "label": "Steel weapon"
        },
        {
          "item": "riftstone_green",
          "qty": 1
        },
        {
          "pool": [
            "silver_ring_might",
            "silver_ring_swift",
            "silver_ring_arcane",
            "silver_ring_ward",
            "silver_neck_might",
            "silver_neck_swift",
            "silver_neck_arcane",
            "silver_neck_ward",
            "silver_earring_might",
            "silver_earring_swift",
            "silver_earring_arcane",
            "silver_earring_ward",
            "silver_belt_might",
            "silver_belt_swift",
            "silver_belt_arcane",
            "silver_belt_ward"
          ],
          "label": "Silver jewel"
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "pool": [
            "mithril_sword",
            "mithril_daggers",
            "mithril_staff",
            "mithril_mace",
            "mithril_waraxe",
            "mithril_rime_daggers"
          ],
          "label": "Mithril weapon"
        }
      ]
    },
    "sapphire": {
      "gem": "sapphire_coffer",
      "segments": [
        {
          "gold": 3000
        },
        {
          "gold": 6000
        },
        {
          "gold": 12000
        },
        {
          "pool": [
            "mithril_helm",
            "nightveil_hood",
            "moonsilk_hat",
            "sanctified_circlet",
            "mithril_gauntlets",
            "nightveil_grips",
            "moonsilk_wraps",
            "sanctified_gloves",
            "mithril_boots",
            "nightveil_treads",
            "moonsilk_slippers",
            "sanctified_boots",
            "mithril_plate",
            "nightveil_jerkin",
            "moonsilk_robe",
            "sanctified_vestment",
            "mithril_shield"
          ],
          "label": "Mithril armor"
        },
        {
          "pool": [
            "mithril_sword",
            "mithril_daggers",
            "mithril_staff",
            "mithril_mace",
            "mithril_waraxe",
            "mithril_rime_daggers"
          ],
          "label": "Mithril weapon"
        },
        {
          "pool": [
            "silver_ring_might",
            "silver_ring_swift",
            "silver_ring_arcane",
            "silver_ring_ward",
            "silver_neck_might",
            "silver_neck_swift",
            "silver_neck_arcane",
            "silver_neck_ward",
            "silver_earring_might",
            "silver_earring_swift",
            "silver_earring_arcane",
            "silver_earring_ward",
            "silver_belt_might",
            "silver_belt_swift",
            "silver_belt_arcane",
            "silver_belt_ward"
          ],
          "label": "Silver jewel"
        },
        {
          "item": "riftstone_green",
          "qty": 2
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "item": "jewelry_scroll",
          "qty": 1
        }
      ]
    },
    "greater_jade": {
      "gem": "greater_jade_coffer",
      "segments": [
        {
          "gold": 4000
        },
        {
          "gold": 8000
        },
        {
          "gold": 15000
        },
        {
          "pool": [
            "mithril_helm",
            "nightveil_hood",
            "moonsilk_hat",
            "sanctified_circlet",
            "mithril_gauntlets",
            "nightveil_grips",
            "moonsilk_wraps",
            "sanctified_gloves",
            "mithril_boots",
            "nightveil_treads",
            "moonsilk_slippers",
            "sanctified_boots",
            "mithril_plate",
            "nightveil_jerkin",
            "moonsilk_robe",
            "sanctified_vestment",
            "mithril_shield"
          ],
          "label": "Mithril armor"
        },
        {
          "item": "riftstone_green",
          "qty": 1
        },
        {
          "pool": [
            "dragon_helm",
            "drakescale_hood",
            "emberweave_hat",
            "dawnforged_circlet",
            "dragon_gauntlets",
            "drakescale_grips",
            "emberweave_wraps",
            "dawnforged_gloves",
            "dragon_boots",
            "drakescale_treads",
            "emberweave_slippers",
            "dawnforged_boots",
            "dragon_plate",
            "drakescale_jerkin",
            "emberweave_robe",
            "dawnforged_vestment",
            "dragon_shield"
          ],
          "label": "Dragon armor"
        },
        {
          "pool": [
            "gold_ring_might",
            "gold_ring_swift",
            "gold_ring_arcane",
            "gold_ring_ward",
            "gold_neck_might",
            "gold_neck_swift",
            "gold_neck_arcane",
            "gold_neck_ward",
            "gold_earring_might",
            "gold_earring_swift",
            "gold_earring_arcane",
            "gold_earring_ward",
            "gold_belt_might",
            "gold_belt_swift",
            "gold_belt_arcane",
            "gold_belt_ward"
          ],
          "label": "Gold jewel"
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "pool": [
            "dragon_sword",
            "dragon_daggers",
            "dragon_staff",
            "dragon_mace",
            "dragon_wingblade",
            "dragon_scythe",
            "dragon_storm_daggers"
          ],
          "label": "Dragon weapon"
        },
        {
          "pool": [
            "titan_sword",
            "titan_greataxe",
            "phantom_daggers",
            "astral_staff",
            "seraphic_mace"
          ],
          "label": "Level 55 weapon",
          "announce": true
        }
      ]
    },
    "greater_sapphire": {
      "gem": "greater_sapphire_coffer",
      "segments": [
        {
          "gold": 10000
        },
        {
          "gold": 20000
        },
        {
          "gold": 40000
        },
        {
          "pool": [
            "dragon_helm",
            "drakescale_hood",
            "emberweave_hat",
            "dawnforged_circlet",
            "dragon_gauntlets",
            "drakescale_grips",
            "emberweave_wraps",
            "dawnforged_gloves",
            "dragon_boots",
            "drakescale_treads",
            "emberweave_slippers",
            "dawnforged_boots",
            "dragon_plate",
            "drakescale_jerkin",
            "emberweave_robe",
            "dawnforged_vestment",
            "dragon_shield"
          ],
          "label": "Dragon armor"
        },
        {
          "pool": [
            "dragon_sword",
            "dragon_daggers",
            "dragon_staff",
            "dragon_mace",
            "dragon_wingblade",
            "dragon_scythe",
            "dragon_storm_daggers"
          ],
          "label": "Dragon weapon"
        },
        {
          "pool": [
            "gold_ring_might",
            "gold_ring_swift",
            "gold_ring_arcane",
            "gold_ring_ward",
            "gold_neck_might",
            "gold_neck_swift",
            "gold_neck_arcane",
            "gold_neck_ward",
            "gold_earring_might",
            "gold_earring_swift",
            "gold_earring_arcane",
            "gold_earring_ward",
            "gold_belt_might",
            "gold_belt_swift",
            "gold_belt_arcane",
            "gold_belt_ward"
          ],
          "label": "Gold jewel"
        },
        {
          "item": "riftstone_blue",
          "qty": 1
        },
        {
          "item": "upgrade_scroll",
          "qty": 1
        },
        {
          "item": "jewelry_scroll",
          "qty": 1
        },
        {
          "pool": [
            "titan_shield",
            "titan_helm",
            "titan_plate",
            "titan_gauntlets",
            "titan_boots",
            "phantom_hood",
            "phantom_jerkin",
            "phantom_grips",
            "phantom_treads",
            "astral_hat",
            "astral_robe",
            "astral_wraps",
            "astral_slippers",
            "seraphic_circlet",
            "seraphic_vestment",
            "seraphic_gloves",
            "seraphic_boots"
          ],
          "label": "Level 55 armor",
          "announce": true
        },
        {
          "pool": [
            "titan_sword",
            "titan_greataxe",
            "phantom_daggers",
            "astral_staff",
            "seraphic_mace"
          ],
          "label": "Level 55 weapon",
          "announce": true
        }
      ]
    }
  }
}
